import { render } from "./world.vue?vue&type=template&id=82935c62&scoped=true"
import script from "./world.vue?vue&type=script&lang=js"
export * from "./world.vue?vue&type=script&lang=js"

import "./world.vue?vue&type=style&index=0&id=82935c62&scoped=true&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82935c62"]])

export default __exports__